import { render, staticRenderFns } from "./ResearchArea.vue?vue&type=template&id=bc3c81e6&scoped=true&"
import script from "./ResearchArea.vue?vue&type=script&lang=ts&"
export * from "./ResearchArea.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc3c81e6",
  null
  
)

export default component.exports